<operation-table>
  <ng-container slot="header">
    <span class="operation-info-header-title">{{ title }}</span>
    <div class="operation-info-header-id">
      <span class="operation-info-header-subtitle">
        {{ id }}
      </span>
      <fw-tooltip [title]="'common.actions.copyToClipboard' | translate">
        <fw-button variant="ghost" class="operation-info-header-id-copy" mat-icon-button
          [cdkCopyToClipboard]="id"><fw-icon color="primary" size="small">copy-item</fw-icon></fw-button>
      </fw-tooltip>
    </div>
  </ng-container>
  <ng-container slot="body">
    <span class="operation-info-body-title">{{ subTitle }}</span>
    <div class="operation-info-body-path">{{ path }}</div>
  </ng-container>
</operation-table>
